<template>
  <div style="padding-top: 5px; width: 830px; background-color: #f5f7f7;">
    <div class="app-main-inner closing-account">
      <div class="app-main-inner-row" style="padding: 0; margin-left: 10px; justify-content: flex-start;">
        <span style="font-size: 16px;">{{ IssueOfTheYear }}</span>
        <span style="font-size: 16px; margin-left: 15px;">{{ TotalOfVouchersEntered }}</span>
      </div>
      <div class="app-main-inner-row" style="margin-left: 10px; margin-bottom: 10px; justify-content: flex-end;">
        <el-button type="primary" :disabled="isInitialPeriod || isProcessing" no="1" @click="openBtnClickHandler">{{ openBtnLabel }}</el-button>
        <el-button type="primary" plain :disabled="isProcessing" no="2" @click="closingBtnClickHandler">{{ $t('CargoMsg.Cargo_CarryOverToNextPeriod') }}</el-button>
      </div>
      <div class="app-main-inner-row" style="margin-top: 323px;" />
    </div>
    <div style="height: 100%; background-color: #e2e8f3;" />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { openFiscalPeriod } from '@/api/financeManage/fiscalPeriod'

export default {
  name: 'ClosingAccount',
  props: {
    accountSet: { type: Object } // 账套
  },
  data() {
    return {
      processing: false
    }
  },
  computed: {
    isInitialPeriod() {
      return this.accountSet ? this.accountSet.currentFiscalPeriod.initialPeriod : false
    },
    IssueOfTheYear() {
      return this.accountSet ? this.$t('CargoMsg.Cargo_IssueOfTheYear').format(this.accountSet.currentFiscalPeriod.year, this.accountSet.currentFiscalPeriod.month) : ''
    },
    TotalOfVouchersEntered() {
      let adCount = ''
      if (this.accountSet && this.accountSet.result) {
        if (this.accountSet.result.adCount !== '') {
          adCount = this.$t('CargoMsg.Cargo_TotalOfVouchersEntered').format(this.accountSet.result.adCount)
        }
      }
      return adCount
    },
    previousFiscalPeriod() {
      const previous = {}
      if (this.accountSet) {
        if (this.accountSet.currentFiscalPeriod.month == 1) {
          previous.month = 12
          previous.year = this.accountSet.currentFiscalPeriod.year - 1
        } else {
          previous.month = this.accountSet.currentFiscalPeriod.month - 1
          previous.year = this.accountSet.currentFiscalPeriod.year
        }
      }
      return previous
    },
    openBtnLabel() {
      return this.accountSet ? this.$t('CargoMsg.Cargo_RCAFTPOY').format(this.previousFiscalPeriod.year, this.previousFiscalPeriod.month) : ''
    },
    isProcessing() {
      return this.processing
    }
  },
  methods: {
    openBtnClickHandler() {
      const requestBody = { 'accountSetKey': this.accountSet.uuid, 'currentFiscalPeriodKey': this.accountSet.currentFiscalPeriod.uuid, 'branchId': this.$store.getters.currentOfficeId }
      if (this.isProcessing) return
      this.processing = true
      this.loading = getLoading()
      openFiscalPeriod(requestBody).then(res => {
        if (res.data !== '') {
          this.$message.success(this.$t('CargoMsg.Cargo_ReversedCloseAccountSuccessfully'))
          this.$nextTick(() => {
            this.accountSet.currentFiscalPeriod = res.data.currentFiscalPeriod
            this.accountSet.result = res.data.result
            this.$emit('openFiscalPeriodSuccess')
          })
        }
      }).finally(() => {
        this.processing = false
        this.loading.close()
      })
    },
    closingBtnClickHandler() {
      if (this.isProcessing) return
      this.$confirm(this.$t('CargoMsg.Cargo_SureToCarryOver'), this.$t('CargoMsg.Cargo_ConfirmR'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        type: 'info'
      }).then(() => {
        this.$emit('closingFiscalPeriodClick')
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
